import { useHistory } from 'react-router-dom';
import { useCurrentArtistIdOrNull } from '../../../artists';
import type { FundraisingLocationState } from '../types';

export function useGoToCurrentArtistHome() {
  const history = useHistory<FundraisingLocationState>();
  const currentArtistId = useCurrentArtistIdOrNull();

  return function goHome() {
    history.push(`/artist/${currentArtistId}/home`);
  };
}
